/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { MonitoringPreferencesTypes, MonitoringPreferencesState } from './types';

const INITIAL_STATE: MonitoringPreferencesState = {
  monitoring_preferences: [],
  request: {
    get_monitoring_preferences: {
      loading: false,
      loaded: false,
      error: false,
    },
    update_monitoring_preferences: {
      loading: false,
      loaded: false,
      error: false,
    },
    delete_monitoring_preferences: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};

const reducer: Reducer<MonitoringPreferencesState> = (
  state = INITIAL_STATE,
  { type, result, monitoring_preference_id },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case MonitoringPreferencesTypes.GET_MONITORING_PREFERENCES_REQUEST:
        draft.request.get_monitoring_preferences = {
          ...INITIAL_STATE.request.get_monitoring_preferences,
          loading: true,
        };
        break;
      case MonitoringPreferencesTypes.GET_MONITORING_PREFERENCES_SUCCESS: {
        if (!result?.data) break;

        const existingIndex = state.monitoring_preferences.findIndex(
          (p) => p.client_id === result.data.client_id,
        );
        if (existingIndex >= 0) {
          draft.monitoring_preferences[existingIndex] = result.data;
        } else {
          draft.monitoring_preferences.push(result.data);
        }
        draft.request.get_monitoring_preferences = {
          ...INITIAL_STATE.request.get_monitoring_preferences,
          loaded: true,
        };
        break;
      }
      case MonitoringPreferencesTypes.GET_MONITORING_PREFERENCES_FAILURE:
        draft.request.get_monitoring_preferences = {
          ...INITIAL_STATE.request.get_monitoring_preferences,
          error: true,
        };
        break;
      case MonitoringPreferencesTypes.UPDATE_MONITORING_PREFERENCES_REQUEST:
        draft.request.update_monitoring_preferences = {
          ...INITIAL_STATE.request.update_monitoring_preferences,
          loading: true,
        };
        break;
      case MonitoringPreferencesTypes.UPDATE_MONITORING_PREFERENCES_SUCCESS: {
        const monitoringPreferenceIndex = state.monitoring_preferences.findIndex(
          (preference) => preference.id === monitoring_preference_id,
        );
        draft.monitoring_preferences[monitoringPreferenceIndex] = result.data;
        draft.request.update_monitoring_preferences = {
          ...INITIAL_STATE.request.update_monitoring_preferences,
          loaded: true,
        };
        break;
      }
      case MonitoringPreferencesTypes.UPDATE_MONITORING_PREFERENCES_FAILURE:
        draft.request.update_monitoring_preferences = {
          ...INITIAL_STATE.request.update_monitoring_preferences,
          error: true,
        };
        break;
      case MonitoringPreferencesTypes.DELETE_MONITORING_PREFERENCES_REQUEST:
        draft.request.delete_monitoring_preferences = {
          ...INITIAL_STATE.request.delete_monitoring_preferences,
          loading: true,
        };
        break;
      case MonitoringPreferencesTypes.DELETE_MONITORING_PREFERENCES_SUCCESS:
        draft.monitoring_preferences = result.data;
        draft.request.delete_monitoring_preferences = {
          ...INITIAL_STATE.request.delete_monitoring_preferences,
          loaded: true,
        };
        break;
      case MonitoringPreferencesTypes.DELETE_MONITORING_PREFERENCES_FAILURE:
        draft.request.delete_monitoring_preferences = {
          ...INITIAL_STATE.request.delete_monitoring_preferences,
          error: true,
        };
        break;

      default:
    }
  });
};

export default reducer;
